import React from "react";
import ReactToggle from "react-toggle";
import "react-toggle/style.css";
import Context from "../../../../../context/Context";

const CSS = {
  main: "i-toggle"
};

export default class DayToggle extends React.Component {

  onChange = (evt) => {
    const v = evt.target.checked;
    if (this.props.onChange) this.props.onChange(v);
  }

  render() {
    return (
      <span className={CSS.main}>
        <ReactToggle id={this.props.id}
          checked={this.props.checked}
          onChange={this.onChange}
          icons={false}
          aria-label={this.props.ariaLabel}
          aria-labelledby={this.props.labelledBy}
          onFocus={this.props.onToggleFocus}
          onBlur={this.props.onToggleBlur} />
      </span>
    );
  }

}